import { initGenericForm } from '../simpleform';
import { getHTML, getUtilityPopupContainer } from '../popups/utility-popups';
import { closeAllUtilityPopups, openUtilityPopup } from '../popups/utils';
import { closeSidenav } from '../navigation/side-nav';

function handleForgot(): void {
    document.addEventListener( 'click', async ( event: Event ) => {
        if ( !event.target || !( event.target instanceof HTMLElement ) || !event.target.classList.contains( 'forgot' ) ) {
            return;
        }

        let passwordResetPopup = document.querySelector( '.popup__container--password-reset' );

        if ( !passwordResetPopup ) {
            const popupContainer = getUtilityPopupContainer();
            passwordResetPopup = await getHTML( 'password-reset-popup' );
            popupContainer.appendChild( passwordResetPopup );
        }

        if ( !passwordResetPopup ) {
            return;
        }

        const form = passwordResetPopup.querySelector( '.twc__simple-form' ) as HTMLFormElement;

        initGenericForm( form );

        closeSidenav();

        closeAllUtilityPopups( false );

        passwordResetPopup.querySelectorAll( '.popup__close' ).forEach( ( btn ) => btn.addEventListener( 'click', () => closeAllUtilityPopups() ) );

        openUtilityPopup( passwordResetPopup );
    } );
}

async function handleSignUp(): Promise<void> {
    async function open() {
        let signUpPopup = document.querySelector( '.popup__container--signup' );

        if ( !signUpPopup ) {
            const popupContainer = getUtilityPopupContainer();
            signUpPopup = await getHTML( 'signup-popup' );
            popupContainer.appendChild( signUpPopup );
        }

        if ( !signUpPopup ) {
            return;
        }

        const form = signUpPopup.querySelector( '.twc__simple-form' ) as HTMLFormElement;

        initGenericForm( form );

        closeSidenav();

        closeAllUtilityPopups( false );

        signUpPopup.querySelectorAll( '.popup__close' ).forEach( ( btn ) => btn.addEventListener( 'click', () => closeAllUtilityPopups() ) );

        openUtilityPopup( signUpPopup );
    }

    document.addEventListener( 'click', function( event ) {
        if ( !event.target || !( event.target instanceof HTMLElement ) || !event.target.classList.contains( 'sign-up' ) ) {
            return;
        }
        open();
    } );
}

function handleLogIn(): void {
    async function open(): Promise<void> {
        let logInPopup = document.querySelector( '.popup__container--signin' );

        if ( !logInPopup ) {
            const popupContainer = getUtilityPopupContainer();
            logInPopup = await getHTML( 'signin-popup' );
            popupContainer.appendChild( logInPopup );
        }

        if ( !logInPopup ) {
            return;
        }

        const form = logInPopup.querySelector( '.twc__simple-form' ) as HTMLFormElement;

        initGenericForm( form );

        logInPopup.querySelectorAll( '.popup__close' ).forEach( ( btn ) => btn.addEventListener( 'click', () => closeAllUtilityPopups() ) );

        closeSidenav();

        closeAllUtilityPopups( false );

        openUtilityPopup( logInPopup );
    }

    window.addEventListener( 'twc:user-signin', open );

    document.addEventListener( 'click', async function handleOpen( event: Event ) {
        if ( !event.target || !( event.target instanceof HTMLElement ) || !event.target.classList.contains( 'log-in' ) ) {
            return;
        }

        event.preventDefault();

        await open();
    } );
}

export default function accountControls(): void {
    handleForgot();
    handleSignUp();
    handleLogIn();
}
